import { Component, OnInit, AfterViewInit } from '@angular/core';
import { StoreService } from "../../../../../shared/services/store.service";
import { NavigationEnd, Router } from "@angular/router";
import { CartService } from "../../../../../shared/services/payment-area/cart.service";
import { DebtPositionsService } from "../../../../../shared/services/personal-area/debt-positions/debt-positions.service";
import { AuthService } from "../../../../../shared/services/auth/auth.service";
import { UserService } from "../../../../../shared/services/user.service";
import { Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailValidator } from 'projects/frontend/src/app/shared/validators/email.validator';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserProfile } from 'projects/frontend/src/app/shared/models/personal-area/user/user-profile';
import { ModalService } from 'projects/frontend/src/app/shared/services/modal.service';

export const pathSegmentContainsPersonalRoute = '/personal';
declare var bootstrap: any;

@Component({
  selector: 'private-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class PrivateFooterComponent implements OnInit, AfterViewInit {
  isLogged$ = this.authService.isLogged$;
  isPersonalRoute: boolean = false;
  private destroyed = new Subject<void>();

  anonimousEmailForm: FormGroup;

  constructor(
    public router: Router,
    private _formBuilder: FormBuilder,
    public storeService: StoreService,
    public authService: AuthService,
    public cartService: CartService,
    public debtPositionsService: DebtPositionsService,
    public userService: UserService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private modalService: ModalService
  ) {
    this.isPersonalRoute = this.isPersonalRouteCalc(this.router.url)
    this.router.events
      .pipe(takeUntil(this.destroyed))
      .subscribe(e => this.isPersonalRoute = e instanceof NavigationEnd ?
        this.isPersonalRouteCalc(e.url) :
        false
      )

    this.anonimousEmailForm = this._formBuilder.group({
      codiceFiscale: [
        '',
        [Validators.required, Validators.pattern('^(?:(?:[a-zA-Z]{6}\\d{2}[a-zA-Z]\\d{2}[a-zA-Z]\\d{3}[a-zA-Z]|[0-9]{11}))$')]
      ],
      emailAddress: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(50)]
      ],
      confirmEmailAddress: [
        '',
        [
          Validators.required,
          Validators.email,
          EmailValidator('emailAddress'),
          Validators.maxLength(50)
        ]
      ]
    });
  }

  isPersonalRouteCalc = (url: string) => {
    return url.includes(pathSegmentContainsPersonalRoute) || (url.includes('payment-return') && this.authService.isLogged())
  }
  getRoute(isPersonalRoute: boolean) {
    const isLogged = this.authService.isLogged();
    let routeUrl = '/personal/payment-area/cart';
    if (!isLogged && !isPersonalRoute) {
      routeUrl = '/services-without-registration/payment-area/cart';
    }
    return routeUrl;
  }
  // readonly getRoute = (isPersonalRoute: boolean) => isPersonalRoute ?
  //   '/personal/payment-area/cart' :
  //   '/services-without-registration/payment-area/cart'

  ngOnInit(): void {
    // Form initialization can happen here
  }

  ngAfterViewInit(): void {
    this.initializeModalEventListeners();
  }

  private initializeModalEventListeners(): void {
    const footerEmailModalId = 'inserimentoEmailAnonimoModal';
    const footerEmailModalEl: any = document.getElementById(footerEmailModalId);

    if (!footerEmailModalEl) {
      console.warn(`Modal element with id '${footerEmailModalId}' not found in DOM. Event listeners not attached.`);
      return;
    }
    footerEmailModalEl.addEventListener('show.bs.modal', (event: any) => {
      this.storeService.emailUtentePagamentoAnonimo = '';
      const cfFromForm = this.storeService.codiceFiscaleUtentePagamentoAnonimo || '';
      const isCfAnonimo = cfFromForm.toUpperCase() === 'ANONIMO';

      // Se ANONIMO e si va su PagoPA (modello 1) e il CF non deve apparire: controllare "modelloPagamento"
      const modelloPagamento = this.storeService.modelloPagamentoAnonimo;
      console.log('modelloPagamento', modelloPagamento);

      if (!isCfAnonimo && cfFromForm !== '') {
        this.anonimousEmailForm.patchValue({ codiceFiscale: cfFromForm });
        this.anonimousEmailForm.get('codiceFiscale')?.setValidators([]);
        this.anonimousEmailForm.get('codiceFiscale')?.updateValueAndValidity();
      } else {
        // CF non deve essere mostrato se modelloPagamento == 1 (PagoPA), a prescindere dal valore del CF; rimuovo validazione e valore
        if (modelloPagamento == 1) {
          this.anonimousEmailForm.patchValue({ codiceFiscale: cfFromForm });
          this.anonimousEmailForm.get('codiceFiscale')?.setValidators([]);
          this.anonimousEmailForm.get('codiceFiscale')?.updateValueAndValidity();
        } else {
          this.anonimousEmailForm.get('codiceFiscale')?.setValidators([
            Validators.required,
            Validators.pattern('^(?:(?:[a-zA-Z]{6}\\d{2}[a-zA-Z]\\d{2}[a-zA-Z]\\d{3}[a-zA-Z]|[0-9]{11}))$')
          ]);
          this.anonimousEmailForm.get('codiceFiscale')?.updateValueAndValidity();
          if (isCfAnonimo) {
            this.anonimousEmailForm.patchValue({ codiceFiscale: '' });
          }
        }
      }
    });
    footerEmailModalEl.addEventListener('hidden.bs.modal', (event: any) => {
      $("body").removeClass("overflow-hidden");
      $(".gb-popup[data-tipo='" + footerEmailModalId + "']").addClass("d-none");

      // Reset form when modal is closed
      this.anonimousEmailForm.reset({
        codiceFiscale: '',
        emailAddress: '',
        confirmEmailAddress: ''
      });
    });
  }

  deleteDebtPosition() {
    this.debtPositionsService.deleteDebtPosition();
  }
  logoutAndGoToHome() {
    this.cartService.svuotaTuttiICarrelli(this.storeService.authority?.codiceIpaEnte ?? '');
    this.authService.logoutAndGoHome();
  }
  loginAndNavigate() {
    this.cartService.svuotaTuttiICarrelli(this.storeService.authority?.codiceIpaEnte ?? '');
    this.authService.navigateToLoginPage();
  }
  logoutAndGoServiceWithoutRegistration() {
    this.authService.logoutAndGoServiceWithoutRegistration();
  }
  deletePersonalData() {
    this.userService.deleteProfileAndPersonalArea()
      .subscribe(() => this.authService.logoutAndGoHome());
  }

  onAddEmail(): void {
    this.storeService.pagamentoIsAnonimo = false; // Reset flag pagamento anonimo
    const email = this.anonimousEmailForm?.get('emailAddress')?.value?.trim();
    const codiceFiscale = this.anonimousEmailForm?.get('codiceFiscale')?.value?.trim()?.toUpperCase();
    if (!email) {
      return;
    }
    // Salvo sempre la mail
    this.storeService.emailUtentePagamentoAnonimo = email;
    // Salvo il CF solo se il campo è effettivamente visibile
    if (this.shouldShowCodiceFiscaleField && codiceFiscale) {
      this.storeService.codiceFiscaleUtentePagamentoAnonimo = codiceFiscale;
      this.storeService.pagamentoIsAnonimo = true;
    }
    const modalElement = document.getElementById('inserimentoEmailAnonimoModal');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
      modalInstance.hide();
    }
    this.toastr.success(
      'La mail è stata aggiunta correttamente',
      'Dati aggiunti'
    );
  }

  /**
   * La popup di inserimento CF e EMAIL per ANONIMO seguirà il seguente flusso:
   *    verrà mostrato il campo CODICE FISCALE:
   *        Per il pagamento di tutte le posizioni con codice fiscale ANONIMO che utilizzano il modello di pagamento  tramite  FlowPay (ex Modello 3) 
   *    NON verrà mostrato il CODICE FISCALE se:
   *        Per il pagamento di tutte le posizioni che utilizzano il modello di pagamento tramite checkout di PagoPA (ex Modello 1), a prescindere dal valore del codice fiscale della posizione 
   *        Per il pagamento di tutte le posizioni con codice fiscale valido (diverso da ANONIMO) che utilizzano il modello di pagamento  tramite  FlowPay (ex Modello 3)
   */
  get shouldShowCodiceFiscaleField(): boolean {
    const cf = (this.storeService.codiceFiscaleUtentePagamentoAnonimo ?? '').trim().toUpperCase();
    const modello = Number(this.storeService.modelloPagamentoAnonimo);
    return cf === 'ANONIMO' && modello === 3;
  }
  // [x]: PAF
  closeExtendedFunctionalitiesPopup() {
    if (this.userService.userProfile != null) {
      this.userService.setUserExtendedFunctionality(this.userService.userProfile)
        .subscribe({
          next: (res: any) => {
            console.log('setUserExtendedFunctionality - res', res);
            if (res && res != null && res == true) {
              this.userService.userPagamentoVeloceFunctionality = false;
              this.userService.userAreaEstesaFunctionality = false;
            }
          },
          error: (error) => {
            console.log(error);
          }
        });
    }
  }
  userFunctionalityActivation(functionality: string) {
    console.log('userFunctionalityActivation', functionality);
    if (functionality == 'pagamentoVeloce') {
      this.debtPositionsService.activeFunctionalityUpdateUserProfile(functionality, true);
    }
    if (functionality == 'areaEstesa') {
      this.debtPositionsService.activeFunctionalityAndUpdatePositionAndProfile(functionality, true);
    }
  }
  userFunctionalityBothActivation() {
    this.debtPositionsService.activeFunctionalityUpdateUserProfile('pagamentoVeloce', true);
    setTimeout(() => {
      this.debtPositionsService.activeFunctionalityAndUpdatePositionAndProfile('areaEstesa', true);
    }, 0);
    // TODO - Non usata: verificare se serve e se i metodi precedenti funzionano
    // this.debtPositionsService.activeBothFunctionalities();
  }
}
